"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTextView = void 0;
const Text_1 = require("../../../Text");
const getTextView = (disabled, error) => {
    let textView;
    if (disabled) {
        textView = Text_1.TEXT_VIEW.light;
    }
    else if (error) {
        textView = Text_1.TEXT_VIEW.error;
    }
    else {
        textView = Text_1.TEXT_VIEW.link;
    }
    return textView;
};
exports.getTextView = getTextView;
//# sourceMappingURL=getTextView.js.map